import { PejerEmbeddables } from '@/Pejer/PejerEmbeddables'
import { log } from 'embeddables/src/Log'
import {
  EmbeddableMessage,
  InitMessage,
  NavigateMessage,
  UpdateSettingsMessage,
  UpdateTokenMessage,
} from 'embeddables/src/types/Message'
import { handleRouteSettings, handleSettings } from './Settings'

export const NAVIGATION_REASON = '__NAVIGATION_REASON'
export const NAVIGATION_REASON_EVENT = 'E'
export const NAVIGATION_REASON_ROUTER = 'R'
export const NAVIGATION_REASON_INDIRECT = 'I'

export const handlePostMessage = (pejer: PejerEmbeddables, event: EmbeddableMessage) => {
  switch (event.type) {
    case 'updateToken':
      handleHeaderEvent(pejer, event.data)
      break
    case 'init':
      handleInitEvent(pejer, event.data)
      break
    case 'navigate':
      handleNavigateEvent(pejer, event.data)
      break
    case 'updateSettings':
      handleSettingsEvent(pejer, event.data)
      break
    case 'updateRouteSettings':
      handleRouteSettings(pejer, event.data)
      break
    case 'multipleMessages':
      event.data.messages.forEach((message) => {
        handlePostMessage(pejer, message)
      })
      break
    default:
      log.error('Unknown event type', event)
  }
}

const handleInitEvent = (pejer: PejerEmbeddables, event: InitMessage['data']) => {
  pejer.parentOrigin.value = event.targetOrigin
  pejer.iframeId.value = event.id
  pejer.routeHandler.setCurrentRouteSettings(event.route)
  pejer.embeddablesVersion = event.embeddablesVersion
}

const handleHeaderEvent = (pejer: PejerEmbeddables, event: UpdateTokenMessage['data']) => {
  pejer.setEmbedToken(event.embedToken)
}

const handleNavigateEvent = async (pejer: PejerEmbeddables, event: NavigateMessage['data']) => {
  pejer.routeHandler.pushRoute(event, NAVIGATION_REASON_EVENT)
}

const handleSettingsEvent = (pejer: PejerEmbeddables, event: UpdateSettingsMessage['data']) => {
  handleSettings(pejer, event)
}
